export default "__VITE_ASSET__Bildt1hR__"